import { I18n } from "i18n-js";
import en from "./locales/en.json";
import cs from "./locales/cs.json";
import it from "./locales/it.json";
import es from "./locales/es.json";
import de from "./locales/de.json";
import fr from "./locales/fr.json";

const i18n = new I18n();

i18n.store({
  en: en,
  cs: cs,
  it: it,
  es: es,
  de: de,
  fr: fr
});

export default i18n;